module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "shop_both_area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "new_soproni_small_area"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "section_title_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "section_title"
  }, [_c('div', {
    staticClass: "section_title_cont text-left"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ked_menu_box"
  }, [_c('div', {
    staticClass: "ked_menu_box_cont"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "rendel_date again_nwpad"
  }, [_c('div', {
    staticClass: "new_one_two"
  }, [_c('div', {
    staticClass: "new_one_two_list text-center"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.$route.path.endsWith('data') || _vm.$route.path.endsWith('final')
    }
  }, [_c('a', {
    staticClass: "no-link"
  }, [_vm._v("1.")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.path.endsWith('data') || _vm.$route.path.endsWith('final'), 'pre-active': _vm.$route.path.endsWith('final')
    }
  }, [_c('a', {
    staticClass: "no-link"
  }, [_vm._v("2.")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.path.endsWith('final')
    }
  }, [_c('a', {
    staticClass: "no-link"
  }, [_vm._v("3.")])])])])]), _vm._v(" "), _vm._m(0)])])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new_one_two"
  }, [_c('div', {
    staticClass: "new_one_two_list below_ontw text-center"
  }, [_c('ul', [_c('li', [_vm._v("Kosár összesítése")]), _vm._v(" "), _c('li', [_vm._v("Adatok ellenőrzése")]), _vm._v(" "), _c('li', [_vm._v("fizetés")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1375e645","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/checkout/Checkout.vue
// module id = 273
// module chunks = 2